import api from './api'

// Look up per-store prices for a scanned barcode (EAN-13 / EAN-8).
// Returns the product payload: { ean, brand, name, quantity, unit, chains: [...] }
export async function getProduct(ean) {
  const { data } = await api.get(`/api/products/${ean}`)
  return data
}
